import React, { useState, useEffect } from 'react';
import './Gallery.css';
import { useModalScrollLock } from '../hooks/useModalScrollLock';

interface DroneProject {
  id: number;
  title: string;
  description: string;
  type: 'image' | 'youtube';
  content: string; // YouTube video ID for embeds or image URL
  category: 'eventos-culturales' | 'eventos-religiosos' | 'deportes' | 'eventos-civicos' | 'turismo-paisajes';
}

interface GalleryProps {
}

// SIORM YouTube video gallery - Videos reales clasificados por tipo de contenido
const droneProjects: DroneProject[] = [
  {
    id: 1,
    title: "Carnaval de Ranchillos 2023 - Tucumán",
    description: "Cobertura aérea del vibrante Carnaval de Ranchillos en Tucumán",
    type: "youtube",
    content: "f0l6dq5LKxk", // 12.9K views
    category: "eventos-culturales"
  },
  {
    id: 2,
    title: "Ke Personajes en Tafí Viejo - Tucumán",
    description: "Evento cultural en Tafí Viejo documentado desde el aire",
    type: "youtube",
    content: "CE6EMdlc1Og", // 6.6K views
    category: "eventos-culturales"
  },
  {
    id: 3,
    title: "Carnaval de Ranchillos 2025 - Tucumán",
    description: "Nueva edición del tradicional carnaval tucumano",
    type: "youtube",
    content: "qtq8f5BfSkU", // 5.6K views
    category: "eventos-culturales"
  },
  {
    id: 4,
    title: "Jorge Newbery Campeón Liga Tucumana",
    description: "Celebración del campeonato de fútbol 2024",
    type: "youtube",
    content: "iFkbs04GiAc", // 5.5K views
    category: "deportes"
  },
  {
    id: 5,
    title: "Atlético Tucumán vs River Plate",
    description: "Cobertura aérea del partido de fútbol histórico",
    type: "youtube",
    content: "KjSdtYRxrlk", // 3.8K views
    category: "deportes"
  },
  {
    id: 6,
    title: "Carnaval de Ranchillos 2023",
    description: "Otra perspectiva del colorido carnaval tucumano",
    type: "youtube",
    content: "vDI7EYSAGic", // 3.6K views
    category: "eventos-culturales"
  },
  {
    id: 7,
    title: "Gran Fiesta de la Independencia Argentina",
    description: "Celebración del 9 de Julio con perspectiva aérea única",
    type: "youtube",
    content: "6JklrlqJfAI", // 3.3K views
    category: "eventos-civicos"
  },
  {
    id: 8,
    title: "Piedra del Águila - Neuquén",
    description: "Paisajes naturales de Neuquén capturados con drone",
    type: "youtube",
    content: "l4RuEsHavSI", // 3.0K views
    category: "turismo-paisajes"
  },
  {
    id: 9,
    title: "Fiesta de Nuestra Señora de Lourdes 2023",
    description: "Festividad religiosa documentada desde el aire",
    type: "youtube",
    content: "AD8vH0ejjcs", // 2.5K views
    category: "eventos-religiosos"
  },
  {
    id: 10,
    title: "9 de Julio - Día de la Independencia",
    description: "Festividades patrias capturadas desde el aire",
    type: "youtube",
    content: "JhzIZO1b_2w", // 2.3K views
    category: "eventos-civicos"
  },
  {
    id: 11,
    title: "Feria de Simoca 2023 - Tucumán",
    description: "Gran feria regional tucumana vista desde el aire",
    type: "youtube",
    content: "yPEc8SuAi20", // 1.3K views
    category: "eventos-culturales"
  },
  {
    id: 12,
    title: "Gruta de la Virgen del Valle - Catamarca",
    description: "Levantamiento aéreo del sitio religioso en Catamarca",
    type: "youtube",
    content: "ulG3N54jCEE", // 970 views
    category: "eventos-religiosos"
  },
  {
    id: 13,
    title: "Fiesta de San Cayetano 2024 - Tucumán",
    description: "Cobertura aérea de las festividades religiosas",
    type: "youtube",
    content: "rChmJDP5T2U", // 935 views
    category: "eventos-religiosos"
  },
  {
    id: 14,
    title: "Carnaval Central Córdoba 2025",
    description: "Filmación aérea del colorido carnaval cordobés",
    type: "youtube",
    content: "LRj_PMBiozk", // 859 views
    category: "eventos-culturales"
  },
  {
    id: 15,
    title: "Marcha de los Bombos Tucumán 2024",
    description: "Vista aérea de la tradicional marcha musical tucumana",
    type: "youtube",
    content: "QASsZgkzM4Y", // 829 views
    category: "eventos-culturales"
  },
  {
    id: 16,
    title: "Tafí del Valle 2023 - Tucumán",
    description: "Paisajes serranos de Tafí del Valle desde el aire",
    type: "youtube",
    content: "188zfX6LryU", // 712 views
    category: "turismo-paisajes"
  },
  {
    id: 17,
    title: "Fiesta Patronal de San Roque 2023",
    description: "Celebración patronal filmada con drone",
    type: "youtube",
    content: "5TjGzO08gFo", // 661 views
    category: "eventos-religiosos"
  },
  {
    id: 18,
    title: "Gruta de la Virgen del Valle",
    description: "Segunda perspectiva del santuario catamarqueño",
    type: "youtube",
    content: "fHu0VRTYgQc", // 645 views
    category: "eventos-religiosos"
  },
  {
    id: 19,
    title: "Seven de Tafí del Valle 2023",
    description: "Torneo de rugby seven en los valles calchaquíes",
    type: "youtube",
    content: "t29w6sE_1fo", // 498 views
    category: "deportes"
  },
  {
    id: 20,
    title: "Pozo de San Francisco - Trancas",
    description: "Exploración aérea de sitios naturales en Trancas",
    type: "youtube",
    content: "QfaNdFK8OmY", // 430 views
    category: "turismo-paisajes"
  }
];

// Función para mezclar aleatoriamente un array (Fisher-Yates shuffle)
const shuffleArray = <T,>(array: T[]): T[] => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const Gallery: React.FC<GalleryProps> = () => {
  const [selectedProject, setSelectedProject] = useState<DroneProject | null>(null);
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const [visibleRows, setVisibleRows] = useState<number>(2); // Mostrar 2 filas inicialmente
  // Mezclar los proyectos una sola vez al cargar el componente
  const [shuffledProjects] = useState<DroneProject[]>(() => shuffleArray(droneProjects));

  // Usar hook para manejar scroll de modal
  useModalScrollLock(!!selectedProject);

  // Manejar cierre del modal con Escape
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && selectedProject) {
        setSelectedProject(null);
      }
    };

    if (selectedProject) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [selectedProject]);

  const categories = ['all', 'eventos-culturales', 'eventos-religiosos', 'deportes', 'eventos-civicos', 'turismo-paisajes'];
  
  const filteredProjects = selectedCategory === 'all' 
    ? shuffledProjects 
    : shuffledProjects.filter(project => project.category === selectedCategory);

  const videosPerRow = 3; // Máximo 3 videos por fila para mejor visualización
  const videosToShow = visibleRows * videosPerRow;
  const currentProjects = filteredProjects.slice(0, videosToShow);
  const hasMoreProjects = filteredProjects.length > videosToShow;

  const handleShowMore = () => {
    if (hasMoreProjects) {
      setVisibleRows(prev => prev + 2);
    } else {
      // Redirigir al canal de YouTube cuando no hay más videos
      window.open('https://www.youtube.com/@SiormDrones', '_blank');
    }
  };

  const renderProjectContent = (project: DroneProject) => {
    switch (project.type) {
      case 'youtube':
        return (
          <div className="youtube-embed">
            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${project.content}?rel=0&modestbranding=1&showinfo=0&controls=1`}
              title={project.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        );
      default:
        return <img src={project.content} alt={project.title} />;
    }
  };

  const handleProjectClick = (project: DroneProject) => {
    // All projects now open in modal, including YouTube videos
    setSelectedProject(project);
  };

  return (
    <section id="gallery" className="gallery">
      <div className="gallery-container">
        <h2 className="gallery-title">Nuestros Trabajos</h2>
        
        <div className="filter-tabs">
          {categories.map(category => (
            <button
              key={category}
              className={`filter-tab ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category === 'all' ? 'Todos' :
               category === 'eventos-culturales' ? 'Eventos Culturales' :
               category === 'eventos-religiosos' ? 'Eventos Religiosos' :
               category === 'deportes' ? 'Deportes' :
               category === 'eventos-civicos' ? 'Eventos Cívicos' :
               'Turismo y Paisajes'}
            </button>
          ))}
        </div>

        <div className="projects-grid">
          {currentProjects.map(project => (
            <div 
              key={project.id} 
              className="project-card"
            >
              <div className="project-image">
                {renderProjectContent(project)}
                <div className="project-overlay">
                  <p className="project-description">{project.description}</p>
                </div>
                {/* Overlay clickeable para capturar todos los clicks */}
                <div 
                  className="project-click-overlay"
                  onClick={() => handleProjectClick(project)}
                  aria-label={`Ver ${project.title} en modal`}
                ></div>
              </div>
            </div>
          ))}
        </div>

        {/* Botón Mostrar más */}
        <div className="show-more-container">
          <button 
            className="show-more-btn" 
            onClick={handleShowMore}
          >
            {hasMoreProjects ? 'Mostrar más videos' : 'Ver canal completo en YouTube'}
          </button>
        </div>

        {selectedProject && (
          <div className="modal modal-no-scroll" onClick={() => setSelectedProject(null)}>
            <div className="modal-content modal-no-scroll" onClick={e => e.stopPropagation()}>
              <button className="modal-close" onClick={() => setSelectedProject(null)}>
                ×
              </button>
              <div className="modal-media modal-no-scroll">
                {selectedProject.type === 'youtube' ? (
                  <div className="modal-youtube">
                    <iframe
                      width="100%"
                      height="100%"
                      src={`https://www.youtube.com/embed/${selectedProject.content}?rel=0&modestbranding=1&showinfo=0&controls=1&autoplay=1`}
                      title={selectedProject.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  </div>
                ) : (
                  <img src={selectedProject.content} alt={selectedProject.title} />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;